import {
  ArrowLeftStroke,
  FileMultipleStroke,
  FilePlusCircleStroke,
  FloppyDisk1Stroke,
  Pencil1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Share1Stroke,
  SignPostLeftStroke,
  Trash3Stroke
} from '@lineiconshq/free-icons';
import React from 'react';
import { AritoActionButton } from '@/components/custom/erp';
import { FormMode } from '@/types/form';

/**
 * Get the title for the form dialog based on form mode and active tab
 */
export const getFormTitle = (formMode: FormMode, activeTab: string) => {
  if (formMode !== 'view') {
    return formMode === 'add' ? 'Mới' : 'Sửa';
  }

  switch (activeTab) {
    case 'info':
      return 'Phiếu kế toán';
    case 'history':
      return 'Lịch sử';
    case 'comment':
      return 'Bình luận';
    default:
      return 'Phiếu kế toán';
  }
};

/**
 * Get the action buttons for the form dialog based on form mode and active tab
 */
export const getFormActionButtons = (
  formMode: FormMode,
  activeTab: string,
  handlers: {
    onAdd?: () => void;
    onEdit?: () => void;
    onDelete?: () => void;
    onCopy?: () => void;
    handleClose: () => void;
  }
) => {
  const { onAdd, onEdit, onDelete, onCopy, handleClose } = handlers;

  if (formMode !== 'view') {
    return (
      <>
        <AritoActionButton title='Lưu' icon={FloppyDisk1Stroke} variant='secondary' type='submit' />
        <AritoActionButton title='Đóng' icon={ArrowLeftStroke} variant='destructive' onClick={handleClose} />
      </>
    );
  }

  switch (activeTab) {
    case 'info':
      return (
        <>
          <AritoActionButton title='In' icon={PrinterStroke} onClick={() => console.log('Print')} />
          <AritoActionButton title='Gửi xử lý' icon={Share1Stroke} onClick={() => console.log('Send')} />
          <AritoActionButton title='Thêm' icon={FilePlusCircleStroke} onClick={onAdd} />
          <AritoActionButton title='Sửa' icon={Pencil1Stroke} onClick={onEdit} />
          <AritoActionButton title='Xóa' icon={Trash3Stroke} onClick={onDelete} />
          <AritoActionButton title='Sao chép' icon={FileMultipleStroke} onClick={onCopy} />
          <AritoActionButton title='Đóng' icon={ArrowLeftStroke} onClick={handleClose} />
        </>
      );
    case 'history':
      return (
        <>
          <AritoActionButton
            title='Refresh'
            variant='secondary'
            icon={RefreshCircle1ClockwiseStroke}
            onClick={() => console.log('refresh')}
          />
          <AritoActionButton
            title='Cố định cột'
            variant='secondary'
            icon={SignPostLeftStroke}
            onClick={() => console.log('pin')}
          />
          <AritoActionButton title='Đóng' variant='secondary' icon={ArrowLeftStroke} onClick={handleClose} />
        </>
      );
    case 'comment':
      return (
        <>
          <AritoActionButton title='Đóng' variant='secondary' icon={ArrowLeftStroke} onClick={handleClose} />
        </>
      );
    default:
      return (
        <>
          <AritoActionButton title='Lưu' icon={FloppyDisk1Stroke} type='submit' />
          <AritoActionButton title='Đóng' icon={ArrowLeftStroke} onClick={handleClose} />
        </>
      );
  }
};

/**
 * Get form subtitle for PhieuKeToan
 */
export const getFormSubTitle = (): string => {
  return 'Phiếu kế toán';
};

/**
 * Check if form is in read-only mode
 */
export const isFormReadOnly = (formMode: FormMode): boolean => {
  return formMode === 'view';
};

/**
 * Get form validation rules based on form mode
 */
export const getFormValidationRules = (formMode: FormMode) => {
  const isReadOnly = isFormReadOnly(formMode);

  return {
    required: !isReadOnly,
    disabled: isReadOnly,
    validateOnChange: !isReadOnly,
    validateOnBlur: !isReadOnly
  };
};
